import { render, staticRenderFns } from "./user-commission.vue?vue&type=template&id=7c70fbf4&"
import script from "./user-commission.vue?vue&type=script&lang=js&"
export * from "./user-commission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports